const lang={
 en:{
  search:"Search",
  gptSearchPlaceholder:"What would you like to watch?"
 }
 ,
  hindi:{
     search:"खोज",
  gptSearchPlaceholder:"आप क्या देखना पसंद करेंगे?"

  }
 ,
 japanese:{
 search:"検索",
  gptSearchPlaceholder:"何を見たいですか？"
 }
}
export default lang